/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ description: NonNullable<unknown> }} Marketing_Footer_TaglineInputs */

const en_marketing_footer_tagline = /** @type {(inputs: Marketing_Footer_TaglineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.description}. Auth, billing, API, realtime, and background work, finished before you start.`)
};

const es_marketing_footer_tagline = /** @type {(inputs: Marketing_Footer_TaglineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.description}. Autenticación, facturación, API, tiempo real y trabajo en segundo plano, terminados antes de que empieces.`)
};

const fr_marketing_footer_tagline = /** @type {(inputs: Marketing_Footer_TaglineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.description}. Authentification, facturation, API, temps réel et traitement en arrière-plan, terminés avant même que vous commenciez.`)
};

/**
* | output |
* | --- |
* | "{description}. Auth, billing, API, realtime, and background work, finished before you start." |
*
* @param {Marketing_Footer_TaglineInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_footer_tagline = /** @type {((inputs: Marketing_Footer_TaglineInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Footer_TaglineInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_footer_tagline(inputs)
	if (locale === "es") return es_marketing_footer_tagline(inputs)
	return fr_marketing_footer_tagline(inputs)
});